module.exports = __webpack_public_path__ + "img/deviceCount.118a28a5.png";